<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.password" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="password" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <otp-input @ready="onReady" :type="password ? 'password' : 'text'" :dense="dense" :length="length" :font-size="fontSize" :placeholder="placeholder" :elevation="elevation" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-actions align="center">
            <code-chunk :pre="false">@ready: {{ ready }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageOtpInput',
  mixins: [
    methods
  ],
  data () {
    return {
      elevation: 'md',
      placeholder: '',
      length: 6,
      fontSize: 2,
      dense: false,
      password: false,
      ready: {}
    }
  },
  methods: {
    onReady ($event) {
      this.log('ready', 'otp-input', $event)
      this.ready = $event
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/otp-input.vue